import { Outlet, NavLink } from "react-router-dom";
import Seo from './Seo'
// import { useSelector, useDispatch } from 'react-redux';
// import { ChangeByPayload } from '../store/ActiveLinkLogic';

import ImgFb from '../img/img_fb.jpg';

const ContattiPage = () => {
return(
<>
<Seo
title = "Contatti"
description = "Contattami per info o un preventivo"
keywords = "contatti - social - cellulare - indizzo"
url="https://giralda-design.web.app/contatti"
immagine={ImgFb}
></Seo>

<Outlet></Outlet>
</>
)};

export default ContattiPage;